import * as types from './constants';

// Update Assignment
export const updateAssignmentRequest = data => (
  { type: types.UPDATE_ASSIGNMENT_REQUEST, payload: data }
);

export const updateAssignmentDone = data => (
  { type: types.UPDATE_ASSIGNMENT_DONE, payload: data }
);

export const updateAssignmentFailed = errors => (
  { type: types.UPDATE_ASSIGNMENT_FAILED, payload: errors }
);

export const updateAssignmentClearErrors = prop => (
  { type: types.UPDATE_ASSIGNMENT_CLEAR_ERRORS, payload: prop }
);

export const updateAssignmentReset = () => (
  { type: types.UPDATE_ASSIGNMENT_RESET }
);